import {StyleSheet} from 'react-native';
import {scale} from "../../../../common/utils";

export default StyleSheet.create({
    cheapCity:{
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems:'center',
    },
    cheapCityText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(14),
        maxWidth: scale(56),
        color: "#333333",
        height: 20,
        lineHeight:20
    },
    cheapDateInfo:{
        marginTop: 4
    },
    cheapDate:{
        flexDirection: 'row',
    },
    cheapDateText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: scale(12),
        color: "#999999",
        height: 17,
    },
    cheapWeekText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: scale(12),
        color: "#999999",
        height: 17,
        marginLeft:4
    },
    transformScale: {
        transform:  [{ scale: 0.8 }],
        transformOrigin: '0% 50%'
    }
});